import React, { Component } from "react";

import "react-datepicker/dist/react-datepicker.css";

import API from "../../apiService.js";
import ALERT from "../component/Alert";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
const SignupSchema = Yup.object().shape({
  weight: Yup.number()
    .typeError("berat badan harus berupa angka")
    // .matches(/^[0-9]+(?:\.[0-9]{0,4})?$/, "Only whole numbers!")
    .transform((_, value) => {
      if (value.includes(".")) {
        return +value.replace(/,/, ".");
      }
      return parseInt(value + ".00");
    })
    .positive(" berat badan harus lebih dari 0")
    .required("berat badan  berat Badan belum diisi"),
  height: Yup.number()
    .typeError("TB harus berupa angka")
    // .matches(/^[0-9]+(?:\.[0-9]{0,4})?$/, "Only whole numbers!")
    .transform((_, value) => {
      if (value.includes(".")) {
        return +value.replace(/,/, ".");
      }
      return parseInt(value + ".00");
    })
    .positive(" tinggi badan harus lebih dari 0")
    .required("tinggi badan belum diisi"),
  sistole: Yup.number()
    .typeError("sistole harus berupa angka")
    .integer(" sistole harus angka")
    .positive(" sistole harus lebih dari 0")
    .required("sistole belum diisi"),
  diastole: Yup.number()
    .typeError("diastole harus berupa angka")
    .integer(" diastole  harus angka")
    .positive(" diastole harus lebih dari 0")
    .required("diastole belum diisi"),
  pulse: Yup.number()
    .typeError("nadi harus berupa angka")
    .integer(" nadi  harus angka")
    .positive(" nadi harus lebih dari 0")
    .required("nadi belum diisi"),
  respiration: Yup.number()
    .typeError("pernapasan harus berupa angka")
    .integer(" pernapasan  harus angka")
    .positive(" pernapasan harus lebih dari 0")
    .required("pernapasan belum diisi"),
});

export class Objektif extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kd_sadar: this.props.patient.kd_sadar,
      refBlood: [],
      data:
        props.patient.examinations.length > 0
          ? props.patient.examinations[0]
          : [],
      refHambatan: [
        { name: "Budaya", status: false },
        { name: "Bahasa", status: false },
        { name: "Fisik", status: false },
        { name: "Religi", status: false },
      ],
      hambatan: [],
      hambatanCheked:
        props.patient.examinations[0].hambatan.length > 1
          ? props.patient.examinations[0].hambatan
          : "",
    };
    this.onChangeHambatan = this.onChangeHambatan.bind(this);
  }

  componentDidMount() {
    this.hambatanCheked();
    this.getBloodType();
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (
      this.props.patient.examinations[0] !== prevProps.patient.examinations[0]
    ) {
      this.setState(
        {
          data:
            this.props.patient.examinations.length > 0
              ? this.props.patient.examinations[0]
              : [],
          hambatanCheked:
            this.props.patient.examinations[0].hambatan.length > 1
              ? this.props.patient.examinations[0].hambatan
              : "",
        },
        () => this.hambatanCheked()
      );
    }
  }
  hambatanCheked() {
    const x = this.state.hambatanCheked;
    const refHambatanNow = this.state.refHambatan;
    let y = [];
    const refHambatan = [];

    if (x.length > 0) {
      y = x.split(",");
      this.setState({ hambatan: y });
      y.map((m, s) => {
        // y[s] = { name: m, status: true };
        refHambatanNow.map((a, b) => {
          if (a.name === m) {
            refHambatan[b] = a;
            refHambatan[b].status = true;
            this.setState({ [refHambatan[b]]: refHambatan[b] });
          }
        });
        // refHambatan.status = true;
        // console.log(refHambatan);
      });
    }
    // console.log(refHambatan);

    // this.setState({ refHambatan: z });
  }

  getBloodType = async () => {
    const res = await API.get("management/blood_types/read");
    if (res.code === 200) {
      this.setState({
        refBlood: res.data,
      });
    }
  };

  handleChangeText = (event) => {
    const value = event.target.value;
    const object = event.target.name;
    let data;
    this.setState(
      (prevState) => ({
        data: {
          // object that we want to update
          ...prevState.data, // keep all other key-value pairs
          [object]: value, // update the value of specific key
        },
      }),
      () => {
        data = { data: [this.state.data], param: "examinations" };
        this.props.parentCallback(data);
      }
    );
  };

  handleSubmit = async () => {
    var param = this.state.data;
    const res = await API.put("registration/examination/update", param);
    if (res.code === 200) {
      this.PutVisit();
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  PutVisit = async () => {
    let visit = {
      id: this.props.patient.id,
      kd_sadar: this.state.kd_sadar,
    };
    let res = await API.put(`registration/change/visit`, { visit });
  };

  onChangeHambatan = (idx) => (event) => {
    const target = event.target;
    const refHambatanNow = this.state.refHambatan;
    let refHambatan = [];
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (value) {
      this.setState({
        hambatan: this.state.hambatan.concat([target.value]),
      });
    } else {
      const ham = this.state.hambatan;
      const x = ham.filter((d, sidx) => d.name !== target.name);
      this.setState({
        hambatan: x,
      });
    }

    refHambatan[idx] = refHambatanNow.filter(
      (d, sidx) => d.name === target.name
    );
    refHambatan[idx][0].status = value;
    refHambatan = refHambatan[idx][0];
    this.setState({
      [refHambatan[idx]]: refHambatan,
    });

    setTimeout(
      function () {
        const hambatan = this.state.hambatan;
        const val = hambatan.toString();

        let data;
        this.setState((prevState) => ({
          data: {
            // object that we want to update
            ...prevState.data, // keep all other key-value pairs
            hambatan: val, // update the value of specific key
          },
        }));
        data = { data: [this.state.data], param: "examinations" };

        this.props.parentCallback(data);
      }.bind(this),
      200
    );
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };
  render() {
    // console.log(this.props.patient);
    var refBlood = this.state.refBlood.map((blood, idx) => {
      return (
        <option key={idx} value={blood.id}>
          {blood.name}
        </option>
      );
    });
    var refHambatan = this.state.refHambatan.map((hambatan, idx) => {
      return (
        <div key={idx} className="row">
          <div className="custom-control custom-checkbox mb-3">
            <input
              className="custom-control-input"
              type="checkbox"
              name={hambatan.name}
              onChange={this.onChangeHambatan(idx)}
              value={hambatan.name}
              id={hambatan.name}
              checked={hambatan.status}
            />
            <label className="custom-control-label" htmlFor={hambatan.name}>
              {hambatan.name}
            </label>
          </div>
        </div>
      );
    });

    return (
      <>
        {this.props.children}
        <Formik
          enableReinitialize
          initialValues={{
            weight: this.state.data.weight,
            height: this.state.data.height,
            sistole: this.state.data.diastole,
            diastole: this.state.data.diastole,
            pulse: this.state.data.pulse,
            respiration: this.state.data.respiration,
            temperature: this.state.data.temperature,
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            this.handleSubmit();
            this.props.nextTab();
            // same shape as initial values
            // console.log(values);
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <div className="fieldset">
                <h2 className="legend">Body</h2>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Tingi Badan / Berat Badan
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="TB"
                        id="height"
                        name="height"
                        onChange={this.handleChangeText}
                        value={this.state.data.height}
                      />
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="BB"
                        id="weight"
                        name="weight"
                        onChange={this.handleChangeText}
                        value={this.state.data.weight}
                      />
                      {errors.weight && touched.weight ? (
                        <div style={{ color: "red" }}>
                          &nbsp; {errors.weight}
                        </div>
                      ) : null}

                      {errors.height && touched.height ? (
                        <div style={{ color: "red" }}>
                          &nbsp; {errors.height}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Tekanan Darah
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="sistole"
                        id="sistole"
                        name="sistole"
                        onChange={this.handleChangeText}
                        value={this.state.data.sistole}
                      />
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="diastole"
                        id="diastole"
                        name="diastole"
                        onChange={this.handleChangeText}
                        value={this.state.data.diastole}
                      />
                      {errors.sistole && touched.sistole ? (
                        <div style={{ color: "red" }}>
                          &nbsp; {errors.sistole}
                        </div>
                      ) : null}

                      {errors.diastole && touched.diastole ? (
                        <div style={{ color: "red" }}>
                          {" "}
                          &nbsp; {errors.diastole}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Nadi/Pernapasan
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="nadi"
                        id="pulse"
                        name="pulse"
                        onChange={this.handleChangeText}
                        value={this.state.data.pulse}
                      />
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="pernapasan"
                        id="respiration"
                        name="respiration"
                        onChange={this.handleChangeText}
                        value={this.state.data.respiration}
                      />
                      {errors.pulse && touched.pulse ? (
                        <div style={{ color: "red" }}>
                          &nbsp; {errors.pulse}
                        </div>
                      ) : null}

                      {errors.respiration && touched.respiration ? (
                        <div style={{ color: "red" }}>
                          &nbsp; {errors.respiration}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Lingkar Perut / Lingkar Kepala
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="Lingkar Perut"
                        id="pabdominal_circumferenceulse"
                        name="abdominal_circumference"
                        onChange={this.handleChangeText}
                        value={
                          this.state.data.abdominal_circumference
                            ? this.state.data.abdominal_circumference
                            : ""
                        }
                      />
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="Lingkar Kepala"
                        id="head_circumference"
                        name="head_circumference"
                        onChange={this.handleChangeText}
                        value={
                          this.state.data.head_circumference
                            ? this.state.data.head_circumference
                            : ""
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Suhu/Golongan darah
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm col-md-6"
                        type="text"
                        placeholder="temp"
                        id="temperature"
                        name="temperature"
                        onChange={this.handleChangeText}
                        value={this.state.data.temperature || 0}
                      />
                      <select
                        className="form-control form-control-sm col-md-6"
                        id="example-text-input"
                        name="blood_type_id"
                        onChange={this.handleChangeText}
                        value={this.state.data.blood_type_id || 0}
                      >
                        {refBlood}
                      </select>
                      {errors.temperature && touched.temperature ? (
                        <div style={{ color: "red" }}>
                          &nbsp; {errors.temperature}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    GCS
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <select
                        className="form-control form-control-sm col-md-4"
                        id="example-text-input"
                        name="gcs_e"
                        defaultValue={this.state.data.gcs_e}
                        onChange={this.handleChangeText}
                      >
                        <option value="4">4</option>
                        <option value="3">3</option>
                        <option value="2">2</option>
                        <option value="1">1</option>
                      </select>
                      <select
                        className="form-control form-control-sm col-md-4"
                        id="example-text-input"
                        name="gcs_v"
                        defaultValue={this.state.data.gcs_v}
                        onChange={this.handleChangeText}
                      >
                        <option value="5">5</option>
                        <option value="4">4</option>
                        <option value="3">3</option>
                        <option value="2">2</option>
                        <option value="1">1</option>
                      </select>
                      <select
                        className="form-control form-control-sm col-md-4"
                        id="example-text-input"
                        name="gcs_m"
                        defaultValue={this.state.data.gcs_m}
                        onChange={this.handleChangeText}
                      >
                        <option value="6">6</option>
                        <option value="5">5</option>
                        <option value="4">4</option>
                        <option value="3">3</option>
                        <option value="2">2</option>
                        <option value="1">1</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Keadaan Umum
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <select
                        className="form-control form-control-sm"
                        id="example-text-input"
                        name="kd_sadar"
                        value={this.state.kd_sadar ? this.state.kd_sadar : "01"}
                        onChange={(val) =>
                          this.setState({
                            kd_sadar: val.target.value,
                          })
                        }
                      >
                        <option>-- Pilih --</option>
                        <option value="01">Compos mentis</option>
                        <option value="02">Somnolence</option>
                        <option value="03">Sopor</option>
                        <option value="04">Coma</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Pemriksaan Fisik
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <label className="col-md-3 col-form-label col-form-label-sm">
                        Kepala
                      </label>
                      <input
                        className="form-control form-control-sm col-md-9"
                        type="text"
                        placeholder="kepala"
                        name="kepala"
                        onChange={this.handleChangeText}
                        value={this.state.data.kepala || ""}
                      />
                    </div>
                    <div className="row">
                      <label className="col-md-3 col-form-label col-form-label-sm">
                        Leher
                      </label>
                      <input
                        className="form-control form-control-sm col-md-9"
                        type="text"
                        placeholder="leher"
                        name="leher"
                        onChange={this.handleChangeText}
                        value={this.state.data.leher || ""}
                      />
                    </div>
                    <div className="row">
                      <label className="col-md-3 col-form-label col-form-label-sm">
                        Dada
                      </label>
                      <input
                        className="form-control form-control-sm col-md-9"
                        type="text"
                        placeholder="dada"
                        name="dada"
                        onChange={this.handleChangeText}
                        value={this.state.data.dada || ""}
                      />
                    </div>

                    <div className="row">
                      <label className="col-md-3 col-form-label col-form-label-sm">
                        Perut
                      </label>
                      <input
                        className="form-control form-control-sm col-md-9"
                        type="text"
                        placeholder="perut"
                        name="perut"
                        onChange={this.handleChangeText}
                        value={this.state.data.perut || ""}
                      />
                    </div>
                    <div className="row">
                      <label className="col-md-3 col-form-label col-form-label-sm">
                        Alat gerak
                      </label>
                      <input
                        className="form-control form-control-sm col-md-9"
                        type="text"
                        placeholder="alat gerak"
                        name="ex_bawah"
                        onChange={this.handleChangeText}
                        value={this.state.data.ex_bawah || ""}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Hambatan
                </label>
                <div className="col-md-7 ">{refHambatan}</div>
              </div> */}
                {/* <div className="form-group row">
                <label className="col-md-5 col-form-label col-form-label-sm">
                  Merokok
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <select
                      className="form-control form-control-sm"
                      name="smoke"
                      onChange={this.handleChangeText}
                      value={
                        this.props.patient.examinations[0].smoke ? "1" : "0"
                      }
                    // defaultValue={this.state.data.smoke}
                    >
                      <option>-- Pilih --</option>
                      <option value="1">YA</option>
                      <option value="0">Tidak</option>
                    </select>
                  </div>
                </div>
              </div> */}
                {/* <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Tindakan Yang diberikan
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Keluhan Pasien"
                      name="physic_anamnese"
                      onChange={this.handleChangeText}
                      value={this.state.data.physic_anamnese}
                    />
                  </div>
                </div>
              </div> */}
              </div>
              <div className="fieldset">
                <h2 className="legend">Mind</h2>
                <div className="col-md-12">
                  <textarea
                    className="form-control form-control-sm"
                    type="text"
                    placeholder="Keluhan Pasien"
                    name="mind"
                    value={this.props.patient.anamneses[0]
                      ? this.props.patient.anamneses[0].anamnese
                      : ""}
                  />
                </div>
              </div>
              <div className="fieldset">
                <h2 className="legend">Soul</h2>
                <div className="form-group row">
                  <label className="col-md-5 col-form-label col-form-label-sm">
                    Merokok
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <select
                        className="form-control form-control-sm"
                        name="smoke"
                        onChange={this.handleChangeText}
                        value={
                          this.state.data.smoke
                        }
                      // defaultValue={this.state.data.smoke}
                      >
                        <option>-- Pilih --</option>
                        <option value="1">YA</option>
                        <option value="0">Tidak</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-5 col-form-label col-form-label-sm">
                    Alkohol
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <select
                        className="form-control form-control-sm"
                        name="alcohol"
                        onChange={this.handleChangeText}
                        value={
                          this.state.data.alcohol
                        }
                      // defaultValue={this.state.data.smoke}
                      >
                        <option>-- Pilih --</option>
                        <option value="1">YA</option>
                        <option value="0">Tidak</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-5 col-form-label col-form-label-sm">
                    Olahraga
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <select
                        className="form-control form-control-sm"
                        name="sport"
                        onChange={this.handleChangeText}
                        value={
                          this.state.data.sport
                        }
                      // defaultValue={this.state.data.smoke}
                      >
                        <option>-- Pilih --</option>
                        <option value="1">YA</option>
                        <option value="0">Tidak</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-5 col-form-label col-form-label-sm">
                    Diet
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <select
                        className="form-control form-control-sm"
                        name="diet"
                        onChange={this.handleChangeText}
                        value={
                          this.state.data.diet
                        }
                      // defaultValue={this.state.data.smoke}
                      >
                        <option>-- Pilih --</option>
                        <option value="1">YA</option>
                        <option value="0">Tidak</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-5 col-form-label col-form-label-sm">
                    Lainnya
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <textarea
                        className="form-control form-control-sm"
                        type="text"
                        placeholder="Lainnya"
                        name="physic_anamnese"
                        onChange={this.handleChangeText}
                        value={this.state.data.physic_anamnese}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
              <button className="btn btn-danger" onClick={this.onReload}>
                Tutup
              </button>
            </Form>
          )}
        </Formik>

        {/* <button className="btn btn-primary" onClick={this.handleSubmit}>
          Simpan
        </button>
        <button className='btn btn-danger' onClick={ this.onReload }>
          Tutup
        </button> */}
      </>
    );
  }
}

export default Objektif;
